export default __webpack_public_path__ + "40f6944101a76a92378b5e6ef1348f4b.png";